<div
  class="notification"
  [class.notification--inverse]="notificationSignal().contrast === notificationContrast.inverse"
  [class.notification--loading]="notificationSignal().type === notificationType.loading"
>
  <div class="notification-content">
    @if (notificationSignal().type === notificationType.loading) {
      <loop-loader-new class="notification-spinner" />
    }

    <div class="flex-col notification-text">
      <div class="notification-title bold">
        {{ notificationSignal().title }}
      </div>
      @if (messageSignal(); as message) {
        <div class="notification-message">
          {{ message }}
        </div>
      }
    </div>

    @if (notificationSignal().link; as link) {
      @if (notificationSignal().type !== notificationType.loading) {
        <loop-link loopAtom="tertiary" (click)="link.actionFn && link.actionFn()">
          {{ link.text }}
        </loop-link>
      }
    }
  </div>

  @if (notificationSignal().type === notificationType.countdown && notificationSignal().durationMs) {
    <div class="notification-progress-track">
      <div
        class="notification-progress-fill"
        [class.notification-progress-fill--expiring]="isExpiringSignal()"
        [style.animation-duration]="notificationSignal().durationMs + 'ms'"
      ></div>
    </div>
  }
</div>
